import { IMAGES } from "./site";

export const RECIPES = [
  {
    id: 1,
    testId: "recipe-card-1",
    title: "Golden Kanji: The Fermented Winter Tonic",
    tag: "Gut Health",
    time: "10 min + 3 days ferment",
    image: IMAGES.goldenMilk,
    imageAlt: "A warm golden spiced drink in a glass on a wooden table",
    excerpt:
      "North India's probiotic heirloom — black carrots, mustard and patience. Your microbiome's favourite festival drink.",
    ingredients: [
      "4 black carrots (or beetroot + regular carrots)",
      "1 tbsp coarsely ground mustard seeds",
      "1 tsp salt, pinch of chilli powder",
      "1 litre filtered water, a clean glass jar",
    ],
    steps: [
      "Cut carrots into batons and add to the jar with mustard, salt, chilli and water.",
      "Cover loosely and keep in a sunny spot for 3-4 days, stirring once daily.",
      "When pleasantly sour, refrigerate. Drink a small glass before meals.",
    ],
  },
  {
    id: 2,
    testId: "recipe-card-2",
    title: "Methi Moong Chilla with Mint Chutney",
    tag: "Diabetes Friendly",
    time: "25 min",
    image: IMAGES.curryBowl,
    imageAlt: "A savoury Indian lentil preparation garnished with fresh herbs",
    excerpt:
      "Protein-forward breakfast that keeps the glucose curve flat and the morning full. The anti-toast.",
    ingredients: [
      "1 cup yellow moong dal, soaked 3 hours",
      "1 cup chopped fresh methi leaves",
      "Ginger, green chilli, cumin, salt",
      "Mint, coriander and lemon for chutney",
    ],
    steps: [
      "Blend soaked dal with ginger, chilli and a splash of water into a pourable batter.",
      "Fold in methi, cumin and salt. Rest 10 minutes.",
      "Ladle onto a hot tawa, cook both sides till golden. Serve with chutney.",
    ],
  },
  {
    id: 3,
    testId: "recipe-card-3",
    title: "Beetroot & Walnut Thoran Bowl",
    tag: "Heart Health",
    time: "30 min",
    image: IMAGES.saladBowl,
    imageAlt: "A vibrant bowl of greens, grains and roasted vegetables",
    excerpt:
      "Kerala-style stir-fry meets the nitrate-rich beet. Served over millet with a walnut crumble.",
    ingredients: [
      "2 beets, grated; curry leaves, mustard seeds",
      "Fresh coconut, turmeric, green chilli",
      "1 cup cooked foxtail millet",
      "Toasted walnuts, lemon",
    ],
    steps: [
      "Splutter mustard and curry leaves; add beet, turmeric and chilli. Cook 6-8 minutes.",
      "Finish with coconut. Toast walnuts separately and crush roughly.",
      "Bowl it: millet base, thoran on top, walnut crumble, lemon squeeze.",
    ],
  },
];
